import axios from "axios";
import normalize from "Utils/normalizer";
import errorHandler from "Utils/error-handler";
import useSession from "Hooks/session.hook";
import { getWithExpiry } from "Helpers/getset-with-expiry";
import { getAccessToken } from "Helpers/session";
import { toLower, omitBy, isEmpty, isNil, map, some } from "lodash";
import { DefaultFilter, Pagination, Sorting } from "./../types/common.types";
import { DriverApprovalStatus, DriverFormInputType } from "./../types/driver_form.types";

const url = `${process.env.API_URL}/${process.env.API_VER}/geocoding`;

interface AddressType {
  type?: string;
  street1: string;
  street2: string;
  postcode: string;
  city: string;
  cityCode?: string;
  state: string;
  stateCode?: string;
  country: string;
}

export const reverseGeocoding = async (address: AddressType) => {
  const accessToken = getAccessToken();
  const { org, profile } = useSession();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/reverse/fetch`,
      data: {
        admin: {
          orgID: org._id,
          profileID: profile._id,
        },
        data: {
          address,
        },
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return normalize.response.reverse_geocoding(response);
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);

    if (!isEmpty(error)) {
      const callback = async () => await reverseGeocoding(address);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const validateGeocoding = async (address: AddressType) => {
  const accessToken = getAccessToken();
  const { org, profile } = useSession();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/address/validation/fetch`,
      data: {
        admin: {
          orgID: org._id,
          profileID: profile._id,
        },
        data: {
          address,
        },
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return normalize.response.validate_geocoding(response);
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);

    if (!isEmpty(error)) {
      const callback = async () => await validateGeocoding(address);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};
